const actions = {
    RESET_CHATR_VALIDATE_MESSAGE: "RESET_CHATR_VALIDATE_MESSAGE",

    ADD_CHATR_BULK_RECHARGE: "ADD_CHATR_BULK_RECHARGE",
    ADD_CHATR_BULK_RECHARGE_SUCCESS: "ADD_CHATR_BULK_RECHARGE_SUCCESS",
    ADD_CHATR_BULK_RECHARGE_FAILED: "ADD_CHATR_BULK_RECHARGE_FAILED",

    GET_CHATR_RECHARGE_REQUEST_LIST: "GET_CHATR_RECHARGE_REQUEST_LIST",
    GET_CHATR_RECHARGE_REQUEST_LIST_SUCCESSFUL: " GET_CHATR_RECHARGE_REQUEST_LIST_SUCCESSFUL",
    GET_CHATR_RECHARGE_REQUEST_LIST_FAILED: " GET_CHATR_RECHARGE_REQUEST_LIST_FAILED",

    GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST: "GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST",
    GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_SUCCESSFUL: "GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_SUCCESSFUL",
    GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_FAILED: "GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_FAILED",

    RESET_CHATR_MESSAGES: 'RESET_CHATR_MESSAGES',

    resetChatrMessage: () => ({
        type: actions.RESET_CHATR_MESSAGES,
    }),

    getChatrBatchTransactionIdRechargeRequest: (data) => ({
        type: actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST,
        payload: { data },
    }),
    getChatrBatchTransactionIdRechargeRequestSuccessful: (result) => ({
        type: actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_FAILED,
        payload: { result },
    }),
    getChatrBatchTransactionIdRechargeRequestFailed: (error) => ({
        type: actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST_FAILED,
        error,
    }),

    getChatrRechargeRequestList: (searchData) => ({
        type: actions.GET_CHATR_RECHARGE_REQUEST_LIST,
        payload: { searchData }
    }),
    getChatrRechargeRequestListSuccessful: (data) => ({
        type: actions.GET_CHATR_RECHARGE_REQUEST_LIST_SUCCESSFUL,
        payload: { data }
    }),
    getChatrRechargeRequestListFailed: (rechargeError) => ({
        type: actions.GET_CHATR_RECHARGE_REQUEST_LIST_FAILED,
        payload: { rechargeError }
    }),

    addChatrBulkRecharge: (data, searchData) => ({
        type: actions.ADD_CHATR_BULK_RECHARGE,
        payload: { data, searchData }
    }),
    addChatrBulkRechargeSuccess: (message) => ({
        type: actions.ADD_CHATR_BULK_RECHARGE_SUCCESS,
        payload: { message }
    }),
    addChatrBulkRechargeFailed: (error) => ({
        type: actions.ADD_CHATR_BULK_RECHARGE_FAILED,
        payload: { error }
    }),
    resetChatrValidateMessage: () => ({
        type: actions.RESET_CHATR_VALIDATE_MESSAGE,
    })
};
export default actions;
